<template>
  <ToolDropWithButtons
    :options="options"
    :is-active="editor.isActive('bulletList')"
    :components="components"
    :set="() => editor.chain().focus().toggleBulletList().run()"
    data-testid="bullet-list-button"
    tooltip="Bullet list"
  >
    <ListDisc />
  </ToolDropWithButtons>
</template>
<script setup lang="ts">
import ToolDropWithButtons from "../_internal/ToolDropWithButtons.vue";
import { ListDisc, ListCircle, ListSquare } from "@topol/icons";
import { Editor } from "@tiptap/core";
import { computed } from "vue";

const components = {
  ListDisc,
  ListCircle,
  ListSquare,
};

const props = defineProps<{
  editor: Editor;
  language?: string;
}>();

const options = computed(() => {
  return [
    {
      icon: "ListDisc",
      set: () => {
        const chain = props.editor.chain().focus();
        if (!props.editor.isActive("bulletList")) {
          chain.toggleBulletList();
        }
        chain.updateAttributes("bulletList", { listStyleType: "disc" }).run();
      },
      isActive: props.editor.isActive("bulletList", {
        listStyleType: "disc",
      }),
    },
    {
      icon: "ListCircle",
      set: () => {
        const chain = props.editor.chain().focus();
        if (!props.editor.isActive("bulletList")) {
          chain.toggleBulletList();
        }
        chain.updateAttributes("bulletList", { listStyleType: "circle" }).run();
      },
      isActive: props.editor.isActive("bulletList", {
        listStyleType: "circle",
      }),
    },
    {
      icon: "ListSquare",
      set: () => {
        const chain = props.editor.chain().focus();
        if (!props.editor.isActive("bulletList")) {
          chain.toggleBulletList();
        }
        chain.updateAttributes("bulletList", { listStyleType: "square" }).run();
      },
      isActive: props.editor.isActive("bulletList", {
        listStyleType: "square",
      }),
    },
  ];
});
</script>
